"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _a, _RawVault_machineSeed, _RawVault_keyStore, _RawVault_vaultStore, _RawVault_deriveVaultKey, _RawVault_argonParams, _RawVault_key;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawVault = void 0;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const hash_wasm_1 = require("hash-wasm");
const idb = __importStar(require("idb-keyval"));
const jose = __importStar(require("jose"));
const uuid = __importStar(require("uuid"));
const ta = __importStar(require("type-assertions"));
const argonBenchmark_1 = require("./argonBenchmark");
const util_1 = require("./util");
const _1 = require(".");
// This has to be outside the class so the static initializers for defaultArgonParams and #machineSeed can reference it.
let resolvers = {};
ta.assert();
class RawVault extends util_1.Revocable(Object.freeze(class {
})) {
    constructor(id, argonParams) {
        super();
        _RawVault_argonParams.set(this, void 0);
        this.meta = new Map();
        _RawVault_key.set(this, void 0);
        this.id = id;
        __classPrivateFieldSet(this, _RawVault_argonParams, argonParams.then(x => Object.freeze(JSON.parse(JSON.stringify(x)))), "f");
    }
    static prepare(params) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __awaiter(this, void 0, void 0, function* () {
            const currentResolvers = resolvers;
            resolvers = undefined;
            if (!currentResolvers) {
                if (params)
                    throw new Error("can't call prepare with a parameters object after vault is already prepared");
                return;
            }
            util_1.setCrypto((_b = params === null || params === void 0 ? void 0 : params.crypto) !== null && _b !== void 0 ? _b : window.crypto);
            util_1.setPerformance((_c = params === null || params === void 0 ? void 0 : params.performance) !== null && _c !== void 0 ? _c : window.performance);
            (_d = currentResolvers.keyStore) === null || _d === void 0 ? void 0 : _d.call(currentResolvers, (_e = params === null || params === void 0 ? void 0 : params.keyStore) !== null && _e !== void 0 ? _e : idb.createStore(util_1.keyStoreUUID, "keyval"));
            (_f = currentResolvers.vaultStore) === null || _f === void 0 ? void 0 : _f.call(currentResolvers, (_g = params === null || params === void 0 ? void 0 : params.vaultStore) !== null && _g !== void 0 ? _g : idb.createStore(util_1.vaultStoreUUID, "keyval"));
            (_h = currentResolvers.machineSeed) === null || _h === void 0 ? void 0 : _h.call(currentResolvers, (_j = (yield idb.get("machineSeed", yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_keyStore)))) !== null && _j !== void 0 ? _j : (yield (() => __awaiter(this, void 0, void 0, function* () {
                const machineSeed = yield (yield util_1.crypto).subtle.importKey("raw", yield (yield util_1.crypto).getRandomValues(new Uint8Array(32)), "HKDF", false, [
                    "deriveBits",
                    "deriveKey",
                ]);
                yield idb.set("machineSeed", machineSeed, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_keyStore));
                return machineSeed;
            }))()));
            (_k = currentResolvers.defaultArgonParams) === null || _k === void 0 ? void 0 : _k.call(currentResolvers, (_l = (yield idb.get("defaultArgonParams", yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_keyStore)))) !== null && _l !== void 0 ? _l : {
                then: (onfulfilled, onrejected) => {
                    return (() => __awaiter(this, void 0, void 0, function* () {
                        const out = {
                            parallelism: 1,
                            memorySize: 32 * 1024,
                            iterations: 26,
                        };
                        const argonBenchmarkResults = yield argonBenchmark_1.argonBenchmark(out.memorySize, 1000, { measureError: true });
                        console.log("argonBenchmarkResults:", argonBenchmarkResults);
                        yield idb.set("argonBenchmarkResults", argonBenchmarkResults, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_keyStore));
                        out.iterations = argonBenchmarkResults.iterations;
                        yield idb.set("defaultArgonParams", out, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_keyStore));
                        return out;
                    }))().then(onfulfilled, onrejected);
                },
            });
        });
    }
    //#region static: VaultFactory<RawVault>
    static open(id, password) {
        return __awaiter(this, void 0, void 0, function* () {
            yield _1.Vault.prepare();
            const factory = (id, argonParams) => __awaiter(this, void 0, void 0, function* () {
                const vaultRevoker = new (util_1.Revocable(class {
                }))();
                const vault = util_1.revocable(new RawVault(id, argonParams), (x) => vaultRevoker.addRevoker(x));
                vault.addRevoker(() => vaultRevoker.revoke());
                return vault;
            });
            const out = yield (() => __awaiter(this, void 0, void 0, function* () {
                if (id !== undefined) {
                    const jwe = yield idb.get(id, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_vaultStore));
                    if (!jwe)
                        throw new Error("can't find specified vault");
                    const protectedHeader = jose.decodeProtectedHeader(jwe);
                    const argonParams = protectedHeader.argon;
                    if (!argonParams)
                        throw new Error("can't decode vault with missing argon parameters");
                    return yield factory(id, Promise.resolve(argonParams));
                }
                else {
                    return yield factory(uuid.v4({
                        random: yield (yield util_1.crypto).getRandomValues(new Uint8Array(16)),
                    }), RawVault.defaultArgonParams);
                }
            }))();
            if (password !== undefined)
                yield out.setPassword(password);
            return out;
        });
    }
    static list() {
        return __awaiter(this, void 0, void 0, function* () {
            yield RawVault.prepare();
            const out = (yield idb.keys(yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_vaultStore)))
                .filter((k) => typeof k === "string")
                .map((k) => k);
            return out;
        });
    }
    static meta(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield RawVault.prepare();
            const jwe = yield idb.get(id, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_vaultStore));
            if (!jwe)
                return undefined;
            const meta = jose.decodeProtectedHeader(jwe).meta;
            if (!meta || !core.isIndexable(meta))
                return undefined;
            const out = new Map();
            Object.entries(meta).forEach(([k, v]) => out.set(k, v));
            return out;
        });
    }
    static delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield RawVault.prepare();
            yield idb.del(id, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_vaultStore));
        });
    }
    setPassword(password) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _RawVault_key, yield __classPrivateFieldGet(RawVault, _a, "m", _RawVault_deriveVaultKey).call(RawVault, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_machineSeed), this.id, yield __classPrivateFieldGet(this, _RawVault_argonParams, "f"), password, (x) => this.addRevoker(x)), "f");
            return this;
        });
    }
    load(deserialize) {
        var _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _RawVault_key, "f"))
                throw new Error("can't load vault until key is set");
            const jwe = yield idb.get(this.id, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_vaultStore));
            if (!jwe)
                throw new Error("can't load missing vault");
            const decryptResult = yield jose.flattenedDecrypt(jwe, __classPrivateFieldGet(this, _RawVault_key, "f"), {
                keyManagementAlgorithms: ["A256KW"],
                contentEncryptionAlgorithms: ["A256GCM"],
            });
            this.meta.clear();
            const meta = (_b = decryptResult.protectedHeader) === null || _b === void 0 ? void 0 : _b.meta;
            if (core.isIndexable(meta)) {
                Object.entries(meta).forEach(([k, v]) => this.meta.set(k, v));
            }
            yield deserialize(decryptResult.plaintext);
            return this;
        });
    }
    save(serialize) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _RawVault_key, "f"))
                throw new Error("can't save vault until key is set");
            const payload = yield serialize();
            //TODO: override the rng used by jose to calculate the CEK and IV with the dependency-injected one.
            const jwe = yield new jose.FlattenedEncrypt(payload)
                .setProtectedHeader({
                alg: "A256KW",
                enc: "A256GCM",
                argon: yield __classPrivateFieldGet(this, _RawVault_argonParams, "f"),
                meta: Array.from(this.meta.entries()).reduce((a, [k, v]) => ((a[k] = v), a), {}),
            })
                .encrypt(__classPrivateFieldGet(this, _RawVault_key, "f"));
            yield idb.set(this.id, jwe, yield __classPrivateFieldGet(RawVault, _a, "f", _RawVault_vaultStore));
            return this;
        });
    }
}
exports.RawVault = RawVault;
_a = RawVault, _RawVault_argonParams = new WeakMap(), _RawVault_key = new WeakMap(), _RawVault_deriveVaultKey = function _RawVault_deriveVaultKey(machineSeed, id, argonParams, password, addRevoker) {
    return __awaiter(this, void 0, void 0, function* () {
        const idBuf = util_1.encoder.encode(id);
        const argonSalt = new Uint8Array(yield (yield util_1.crypto).subtle.deriveBits({
            name: "HKDF",
            hash: "SHA-256",
            salt: idBuf,
            info: util_1.encoder.encode("argonSalt"),
        }, machineSeed, 128));
        const argonKey = yield hash_wasm_1.argon2id(Object.assign(Object.assign({}, argonParams), { password, salt: argonSalt, hashLength: 32, outputType: "binary" }));
        // It might make more logical sense to use the argon-derived key in the salt field, but both fields provide
        // equivalent security, and using idBuf as the seed in both places permits some optimization by sharing
        // the result of HDKF-Extract between both calculations. (This isn't done right now, and can't be done with
        // the WebCrypto API as it is, but maybe we'll use something else some day.)
        const vaultKey = yield (yield util_1.crypto).subtle.deriveKey({
            name: "HKDF",
            hash: "SHA-256",
            salt: idBuf,
            info: argonKey,
        }, machineSeed, {
            name: "AES-KW",
            length: 256,
        }, false, ["wrapKey", "unwrapKey"]);
        //TODO: Returning a revocable doesn't work here; WebCrypto in the browser complains about the proxy. Fix this.
        return vaultKey;
        // return revocable(vaultKey, addRevoker);
    });
};
//#region static: prepare()
RawVault.defaultArgonParams = new Promise((resolve) => resolvers && (resolvers.defaultArgonParams = resolve));
// Caching the machine seed also conveniently hides the inability of the fake-indexeddb package to store CryptoKey objects.
_RawVault_machineSeed = { value: new Promise((resolve) => resolvers && (resolvers.machineSeed = resolve)) };
_RawVault_keyStore = { value: new Promise((resolve) => resolvers && (resolvers.keyStore = resolve)) };
_RawVault_vaultStore = { value: new Promise((resolve) => resolvers && (resolvers.vaultStore = resolve)) };
Object.freeze(RawVault);
Object.freeze(RawVault.prototype);
Object.freeze(Object.getPrototypeOf(RawVault));
